import base from "./base.service";

const instance = base.service();

export const getAll = () => {
    return instance.get("/kategorijaClanka/all"); 
};

export const getById = (id) =>
{
    return instance.get(`/kategorijaClanka/${id}`);
}

export default {
    getAll, getById
};